export const EDES_MILESTONE_CATALOG_ID = "edes-court-milestones-v1";

export const EDES_MILESTONE_PROJECTS = [
  { project_id: "Edes Court", catalog_id: EDES_MILESTONE_CATALOG_ID },
];

export const EDES_MILESTONE_ROWS = [
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "1",
    task_order: 1,
    operation: "Construction Loan Finalized",
    operation_key: "CONSTRUCTION_LOAN_FINALIZED",
    duration_days: 0,
    planned_start: "2026-05-01",
    planned_finish: "2026-05-01",
    section: "Final Map / Improvement Plans",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "2",
    task_order: 2,
    operation: "Prepare Documents",
    operation_key: "PREPARE_DOCUMENTS",
    duration_days: 60,
    planned_start: "2026-04-06",
    planned_finish: "2026-06-05",
    section: "Final Map / Improvement Plans",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "3",
    task_order: 3,
    operation: "Review Cycle 1",
    operation_key: "REVIEW_CYCLE_1",
    duration_days: 30,
    planned_start: "2026-06-05",
    planned_finish: "2026-07-21",
    section: "Final Map / Improvement Plans",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "4",
    task_order: 4,
    operation: "Revise and Resubmit",
    operation_key: "REVISE_AND_RESUBMIT_1",
    duration_days: 20,
    planned_start: "2026-07-21",
    planned_finish: "2026-08-18",
    section: "Final Map / Improvement Plans",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "5",
    task_order: 5,
    operation: "Review Cycle 2",
    operation_key: "REVIEW_CYCLE_2",
    duration_days: 30,
    planned_start: "2026-08-18",
    planned_finish: "2026-09-30",
    section: "Final Map / Improvement Plans",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "6",
    task_order: 6,
    operation: "Revise and Resubmit",
    operation_key: "REVISE_AND_RESUBMIT_2",
    duration_days: 20,
    planned_start: "2026-09-30",
    planned_finish: "2026-10-29",
    section: "Final Map / Improvement Plans",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "7",
    task_order: 7,
    operation: "Review Cycle 3",
    operation_key: "REVIEW_CYCLE_3",
    duration_days: 20,
    planned_start: "2026-10-29",
    planned_finish: "2026-11-30",
    section: "Final Map / Improvement Plans",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "8",
    task_order: 8,
    operation: "Final Map Checklist Items",
    operation_key: "FINAL_MAP_CHECKLIST_ITEMS",
    duration_days: 5,
    planned_start: "2026-11-30",
    planned_finish: "2026-12-07",
    section: "Final Map / Improvement Plans",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "9",
    task_order: 9,
    operation: "Revise and Resubmit",
    operation_key: "REVISE_AND_RESUBMIT_3",
    duration_days: 10,
    planned_start: "2026-12-07",
    planned_finish: "2026-12-21",
    section: "Final Map / Improvement Plans",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "10",
    task_order: 10,
    operation: "Approval + Processing",
    operation_key: "APPROVAL_AND_PROCESSING",
    duration_days: 10,
    planned_start: "2026-12-21",
    planned_finish: "2027-01-05",
    section: "Final Map / Improvement Plans",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "11",
    task_order: 11,
    operation: "Prepare Construction Documents (A/S/M/E/P/T24)",
    operation_key: "PREPARE_CONSTRUCTION_DOCUMENTS",
    duration_days: 60,
    planned_start: "2026-04-06",
    planned_finish: "2026-06-29",
    section: "Building Construction Documents",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "12",
    task_order: 12,
    operation: "Plan Cycle 1",
    operation_key: "PLAN_CYCLE_1",
    duration_days: 20,
    planned_start: "2026-06-29",
    planned_finish: "2026-07-27",
    section: "Building Construction Documents",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "13",
    task_order: 13,
    operation: "Revise and Resubmit",
    operation_key: "REVISE_AND_RESUBMIT_4",
    duration_days: 20,
    planned_start: "2026-07-27",
    planned_finish: "2026-08-24",
    section: "Building Construction Documents",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "14",
    task_order: 14,
    operation: "Plan Cycle 2",
    operation_key: "PLAN_CYCLE_2",
    duration_days: 20,
    planned_start: "2026-08-24",
    planned_finish: "2026-09-21",
    section: "Building Construction Documents",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "15",
    task_order: 15,
    operation: "Revise and Resubmit",
    operation_key: "REVISE_AND_RESUBMIT_5",
    duration_days: 10,
    planned_start: "2026-09-21",
    planned_finish: "2026-10-05",
    section: "Building Construction Documents",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "16",
    task_order: 16,
    operation: "Plan Cycle 3",
    operation_key: "PLAN_CYCLE_3",
    duration_days: 20,
    planned_start: "2026-10-05",
    planned_finish: "2026-11-02",
    section: "Building Construction Documents",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "17",
    task_order: 17,
    operation: "Revise and Resubmit",
    operation_key: "REVISE_AND_RESUBMIT_6",
    duration_days: 5,
    planned_start: "2026-11-02",
    planned_finish: "2026-11-09",
    section: "Building Construction Documents",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "18",
    task_order: 18,
    operation: "Building Permit Issuance + Processing",
    operation_key: "BUILDING_PERMIT_ISSUANCE_AND_PROCESSING",
    duration_days: 10,
    planned_start: "2026-11-09",
    planned_finish: "2026-11-23",
    section: "Building Construction Documents",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "19",
    task_order: 19,
    operation: "Site Clearing/BMP Install",
    operation_key: "SITE_CLEARING_BMP_INSTALL",
    duration_days: 5,
    planned_start: "2027-01-10",
    planned_finish: "2027-01-15",
    section: "Site Development",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "20",
    task_order: 20,
    operation: "Rough Grade Site Pt 1",
    operation_key: "ROUGH_GRADE_SITE_PT_1",
    duration_days: 5,
    planned_start: "2027-01-15",
    planned_finish: "2027-01-22",
    section: "Site Development",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "21",
    task_order: 21,
    operation: "Retaining Walls",
    operation_key: "RETAINING_WALLS",
    duration_days: 20,
    planned_start: "2027-01-22",
    planned_finish: "2027-02-19",
    section: "Site Development",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "22",
    task_order: 22,
    operation: "Backfill Retaining Walls and Finish Rough Grade",
    operation_key: "BACKFILL_RETAINING_WALLS_AND_FINISH_ROUGH_GRADE",
    duration_days: 5,
    planned_start: "2027-02-19",
    planned_finish: "2027-02-26",
    section: "Site Development",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "23",
    task_order: 23,
    operation: "Sewer",
    operation_key: "SEWER",
    duration_days: 10,
    planned_start: "2027-02-26",
    planned_finish: "2027-03-12",
    section: "Site Development",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "24",
    task_order: 24,
    operation: "Storm",
    operation_key: "STORM",
    duration_days: 15,
    planned_start: "2027-03-12",
    planned_finish: "2027-04-02",
    section: "Site Development",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "25",
    task_order: 25,
    operation: "Water",
    operation_key: "WATER",
    duration_days: 8,
    planned_start: "2027-04-02",
    planned_finish: "2027-04-14",
    section: "Site Development",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "26",
    task_order: 26,
    operation: "Joint Trench",
    operation_key: "JOINT_TRENCH",
    duration_days: 15,
    planned_start: "2027-04-14",
    planned_finish: "2027-05-05",
    section: "Site Development",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "27",
    task_order: 27,
    operation: "Pavers",
    operation_key: "PAVERS",
    duration_days: 30,
    planned_start: "2027-05-05",
    planned_finish: "2027-06-16",
    section: "Site Development",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "28",
    task_order: 28,
    operation: "Building 1",
    operation_key: "BUILDING_1",
    duration_days: 120,
    planned_start: "2027-04-07",
    planned_finish: "2027-09-22",
    section: "Construction Schedule For Future Buildings",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "29",
    task_order: 29,
    operation: "Building 2",
    operation_key: "BUILDING_2",
    duration_days: 120,
    planned_start: "2027-04-27",
    planned_finish: "2027-10-12",
    section: "Construction Schedule For Future Buildings",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "30",
    task_order: 30,
    operation: "Building 3",
    operation_key: "BUILDING_3",
    duration_days: 120,
    planned_start: "2027-05-17",
    planned_finish: "2027-11-01",
    section: "Construction Schedule For Future Buildings",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "31",
    task_order: 31,
    operation: "Building 4",
    operation_key: "BUILDING_4",
    duration_days: 120,
    planned_start: "2027-05-22",
    planned_finish: "2027-11-05",
    section: "Construction Schedule For Future Buildings",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "32",
    task_order: 32,
    operation: "Building 5",
    operation_key: "BUILDING_5",
    duration_days: 120,
    planned_start: "2027-06-08",
    planned_finish: "2027-11-23",
    section: "Construction Schedule For Future Buildings",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "33",
    task_order: 33,
    operation: "Building 6",
    operation_key: "BUILDING_6",
    duration_days: 120,
    planned_start: "2027-06-13",
    planned_finish: "2027-11-26",
    section: "Construction Schedule For Future Buildings",
  },
  {
    catalog_id: EDES_MILESTONE_CATALOG_ID,
    task_id: "34",
    task_order: 34,
    operation: "Building 7",
    operation_key: "BUILDING_7",
    duration_days: 120,
    planned_start: "2027-06-18",
    planned_finish: "2027-12-03",
    section: "Construction Schedule For Future Buildings",
  },
];

export function sortEdesMilestoneRows(rows = []) {
  return [...rows].sort((a, b) => {
    const aOrder = Number(a?.task_order ?? a?.task_id ?? 0);
    const bOrder = Number(b?.task_order ?? b?.task_id ?? 0);
    return aOrder - bOrder;
  });
}
